// import React from "react";
// import moment from "moment";
import axios from "axios";

export const _buildingIDs = "b-1-240-south-street-10002 b-1-206-e-94th-st-10128 b-1-25-broad-st-10004 b-1-18-thames-st-10006 b-1-128-william-st-10038 b-1-168-w-96th-st-10025 b-1-50-west-st-10006 b-1-532-w-123rd-st-10027 b-1-217-w-57th-st-10019 b-1-13-w-61st-st-10023 b-1-206-washington-st-10007 b-1-537-greenwich-st-10013 b-1-53-w-53rd-st-10019 b-1-78-king-st-10014 b-1-111-murray-st-10007 b-1-389-e-89th-st-10128 b-1-408-w-52nd-st-10019 b-1-108-leonard-st-10013 b-1-356-central-park-w-10025 b-1-56-leonard-st-10013 b-1-122-e-23rd-st-10010 b-1-350-e-23rd-st-10010 b-1-177-w-137th-st-10030 b-1-212-e-20th-st-10003 b-1-281-5th-ave-10016 b-1-138-e-50th-st-10022 b-1-30-e-29th-st-10016 b-1-216-central-park-s-10019 b-1-68-watts-st-10013 b-1-200-e-62nd-st-10065 b-1-540-w-49th-st-10019 b-1-200-w-151st-st-10039 b-1-200-amsterdam-ave-10023 b-1-91-leonard-st-10013 b-1-23-park-row-10038 b-1-200-e-95th-st-10128 b-1-230-w-76th-st-10023 b-1-100-e-53rd-st-10022 b-1-29-reade-st-10007 b-1-196-orchard-st-10002 b-1-32-trinity-pl-10006 b-1-405-w-149th-st-10031 b-1-80-lexington-ave-10016 b-1-41-e-22nd-st-10010 b-1-705-w-184th-st-10033 b-1-607-w-56th-st-10019 b-1-194-e-101st-st-10029 b-1-587-3rd-ave-10016 b-1-1377-park-ave-10029 b-1-654-e-12th-st-10009 b-1-172-madison-ave-10016 b-1-200-e-59th-st-10022 b-1-200-e-21st-st-10010 b-1-707-w-186th-st-10033 b-1-1281-lexington-ave-10028 b-1-68-w-139th-st-10037 b-1-304-mulberry-st-10012 b-1-275-w-10th-st-10014 b-1-321-w-99th-st-10025 b-1-568-broome-st-10013 b-1-48-w-30th-st-10001 b-1-45-park-pl-10007 b-1-154-e-23rd-st-10010 b-1-1790a-3rd-ave-10029 b-1-1353-1st-ave-10021 b-1-244-w-111th-st-10026 b-1-180-e-88th-st-10128 b-1-302-e-96th-st-10128 b-1-310-w-133rd-st-10030 b-1-101-w-78th-st-10024 b-1-72-vestry-st-10013 b-1-494-w-end-ave-10024 b-1-124-suffolk-st-10002 b-1-551-w-21st-st-10011 b-1-1635-lexington-ave-10029 b-1-20-e-end-ave-10028 b-1-30-e-31st-st-10016 b-1-510-w-28th-st-10001 b-1-1182-broadway-10001 b-1-196-mulberry-st-10012 b-1-273-w-87th-st-10024 b-1-448-w-167th-st-10032 b-1-212-w-95th-st-10025 b-1-350-w-71st-st-10023 b-1-525-w-27th-st-10001 b-1-90-morton-street-10014 b-1-301-e-81st-st-10028 b-1-2-park-pl-10007 b-1-30-e-1st-st-10003 b-1-520-park-ave-10065 b-1-301-e-61st-st-10065 b-1-48-e-132nd-st-10037 b-1-250-w-81st-st-10024 b-1-322-w-52nd-st-10019 b-1-399-e-8th-st-10009 b-1-58-w-111th-st-10026 b-1-118-e-59th-st-10022 b-1-42-east-end-avenue-10028 b-1-522a-w-29th-st-10001 b-1-287-e-houston-st-10002 b-1-30-warren-st-10007 b-1-815-w-179th-st-10033 b-1-171a-henry-st-10002 b-1-325b-w-broadway-10013 b-1-75-1st-ave-10003 b-1-333-e-62nd-st-10065 b-1-426-w-128th-st-10027 b-1-75-e-110th-st-10029 b-1-550-w-29th-st-10001 b-1-27-wooster-st-10013 b-1-460-w-130th-st-10027 b-1-688-broadway-10012 b-1-2903-frederick-douglass-blvd-10039 b-1-308-w-113th-st-10026 b-1-111-leroy-st-10014 b-1-515-w-29th-st-10001 b-1-553-w-end-ave-10024 b-1-1010-park-ave-10028 b-1-76-e-10th-st-10003 b-1-12-warren-st-10007 b-1-371-w-126th-st-10027 b-1-21-white-st-10013 b-1-221-chrystie-st-10002 b-1-324-e-4th-st-10009 b-1-197-mott-st-10012 b-1-601-washington-st-10014 b-1-336-e-54th-st-10022 b-1-163-w-80th-st-10024 b-3-203-livingston-st-11201 b-3-126-willoughby-st-11201 b-3-464-wythe-ave-11249 b-3-6-nevins-st-11217 b-3-51-york-st-11201 b-3-109-montgomery-st-11225 b-3-5-clinton-st-11201 b-3-50-bridge-park-drive-11201 b-3-1587-e-19th-st-11230 b-3-575-4th-ave-11215 b-3-559-pacific-st-11217 b-3-227-9th-st-11215 b-3-1325-herkimer-st-11233 b-3-248-webster-ave-11230 b-3-651-new-york-ave-11203 b-3-68-schermerhorn-st-11201 b-3-345-carroll-st-11231 b-3-382-eastern-pkwy-11225 b-3-36-maspeth-ave-11211 b-3-350-hicks-st-11201 b-3-211-schermerhorn-st-11201 b-3-42-jay-st-11201 b-3-300-n-7th-st-11211 b-3-609-baltic-st-11217 b-3-138-15th-st-11215 b-3-432-keap-st-11211 b-3-2881-nostrand-ave-11229 b-3-954-bergen-st-11216 b-3-869-57th-st-11220 b-3-2533-ocean-ave-11229 b-3-15-e-19th-st-11226 b-3-2515-voorhies-ave-11235 b-3-98-stockton-st-11206 b-3-840-metropolitan-ave-11211 b-3-108-stockton-st-11206 b-3-134-stockton-st-11206 b-3-8707-19th-ave-11214 b-3-7819-bay-pkwy-11214 b-3-1229-putnam-ave-11221 b-3-557-hart-st-11221 b-3-26-avenue-p-11204 b-3-4907-4th-ave-11220 b-3-1801-foster-ave-11230 b-3-196-21st-st-11232 b-3-856-washington-ave-11238 b-3-799-washington-ave-11238 b-3-112-pacific-st-11201 b-3-1663-e-19th-st-11229 b-3-401-95th-st-11209 b-3-67-livingston-st-11201 b-3-906-prospect-pl-11213 b-3-73-greene-ave-11238 b-3-309-ocean-pkwy-11218 b-3-196-e-7th-st-11218 b-3-178-concord-st-11201 b-3-241-4th-ave-11215 b-3-933-atlantic-ave-11238 b-3-1404-ocean-pkwy-11230 b-3-305-union-ave-11211 b-3-5416-3rd-ave-11220 b-3-145-president-st-11231 b-3-348-henry-st-11201 b-3-806-dekalb-ave-11221 b-3-268-bay-ridge-ave-11220 b-3-70-lorimer-st-11206 b-3-2-saint-marks-pl-11217 b-3-241-19th-st-11215 b-3-653-5th-ave-11215 b-3-21-powers-st-11211 b-3-585-manhattan-ave-11222 b-3-160-west-st-11222 b-3-189-cooper-st-11207 b-3-169-bay-34th-st-11214 b-3-1702-newkirk-ave-11226 b-3-2126-gerritsen-avenue-11229 b-3-362-van-brunt-st-11231 b-3-9907-3rd-ave-11209 b-3-1430-w-4th-st-11204 b-3-1924-ocean-ave-11230 b-3-1683-w-7th-st-11223 b-3-488-4th-ave-11215 b-3-1128-67th-st-11219 b-3-67-warren-st-11201 b-3-242-wallabout-st-11206 b-3-710-grand-st-11211 b-3-8-downing-st-11238 b-3-253-tompkins-ave-11216 b-3-27-kossuth-pl-11221 b-3-3311-newkirk-ave-11203 b-3-245-schaefer-st-11207 b-3-311-hart-st-11206 b-3-594-marcy-ave-11206 b-4-2315-44th-dr-11101 b-4-13105-40th-rd-11354 b-4-13101-40th-rd-11354 b-4-2711-42nd-rd-11101 b-4-22-18-jackson-avenue-11101 b-4-3806-union-st-11354 b-4-4511-82nd-st-11373 b-4-4502-83rd-st-11373 b-4-1442-110th-st-11356 b-4-6540-austin-st-11374 b-4-3360-farrington-st-11354 b-4-2412-queens-plz-s-11101 b-4-3902-prince-st-11354 b-4-2130-44th-dr-11101 b-4-150-beach-117th-st-11694 b-4-8714-51st-ave-11373 b-4-1053-46th-rd-11101 b-4-2701-thomson-ave-11101 b-4-7166-parsons-blvd-11365 b-4-15815-union-tpke-11366 b-4-2347-31st-rd-11106 b-4-13327-39th-ave-11354 b-4-527-48th-ave-11101 b-4-4142-college-point-blvd-11355 b-4-4102-27th-st-11101 b-4-2412-42nd-rd-11101 b-4-14904-northern-blvd-11354 b-4-14328-41st-ave-11355 b-4-8914-150th-st-11435 b-4-4250-27th-st-11101 b-4-2101-30th-rd-11102 b-4-14438-35th-ave-11354 b-4-2818-astoria-blvd-11102 b-4-3343-junction-blvd-11372 b-4-2515-27th-st-11102 b-4-9740-64th-ave-11374 b-4-1126-45th-rd-11101 b-4-4705-5th-st-11101 b-4-11224-38th-ave-11368 b-4-3110-28th-rd-11102 b-4-5119-van-loon-st-11373 b-4-4283-hunter-st-11101 b-4-4118-27th-st-11101 b-4-2540-38th-st-11103 b-4-2337-31st-rd-11106 b-4-3147-137th-st-11354 b-4-2914-newtown-ave-11102 b-1-323-e-52nd-st-10022 b-3-185-18-street-11215 b-3-105-york-st-11201 b-3-1-clinton-st-11201 b-3-611-4th-ave-11215 b-4-3519-leavitt-st-11354 b-1-320-w-52nd-st-10019 b-3-180-front-st-11201 b-1-532-w-33rd-st-10001 b-1-545-w-30th-st-10001";

export const _buildingSlugs = ["220-central-park-south-10019", "217-west-57th-street-10019", "200-amsterdam-avenue-10023", "100-barclay-street-10007", "138-willoughby-street-11201", "11-hoyt-street-11201", "520-park-avenue-10065", "130-william-street-10038", "2315-44th-drive-11101", "111-murray-street-10007", "125-greenwich-street-10006", "20-east-end-avenue-10028", "565-broome-street-10013", "520-west-28th-street-10001", "56-leonard-street-10013", "30-east-29th-street-10016", "53-west-53rd-street-10019", "40-bleecker-street-10012", "85-jay-street-11201", "688-broadway-10012", "302-east-96th-street-10128", "252-south-street-10002", "429-kent-avenue-11249", "45-park-place-10007", "522-west-29th-street-10001", "555-west-end-avenue-10024", "108-leonard-street-10013", "2130-44th-drive-11101", "50-bridge-park-drive-11201", "543-west-122nd-street-10027", "196-orchard-street-10002", "308-north-7th-street-11211", "432-park-avenue-10022", "91-leonard-street-10013", "1-clinton-street-11201", "100-east-53rd-street-10022", "138-east-50th-street-10022", "1865-broadway-10023", "45-east-22nd-street-10010", "75-kenmare-street-10012", "77-greenwich-street-10006", "111-west-57th-street-10019", "168-plymouth-street-11201", "30-warren-street-10007", "389-east-89th-street-10128", "111-montgomery-street-11225", "180-east-88th-street-10128", "21-powers-street-11211", "25-park-row-10038", "4283-hunter-street-11101", "570-broome-street-10013", "1-manhattan-square-10002", "100-franklin-street-10013", "121-east-22nd-street-10010", "172-madison-avenue-10016", "215-chrystie-street-10002", "25-broad-street-10004", "250-west-81st-street-10024", "30-east-31st-street-10016", "50-west-street-10006", "561-pacific-street-11217", "1010-park-avenue-10028", "15-west-61st-street-10023", "200-east-95th-street-10128", "2416-queens-plaza-south-11101", "243-4th-avenue-11215", "264-webster-avenue-11230", "287-east-houston-street-10002", "350-hicks-street-11201", "350-west-71st-street-10023", "533-48th-avenue-11101", "550-west-29th-street-10001", "611-west-56th-street-10019", "67-livingston-street-11201", "75-greene-avenue-11238", "77-charlton-street-10014", "10-lenox-avenue-10026", "111-leroy-street-10014", "133-beach-116th-street-11694", "13327-39th-avenue-11354", "13437-35th-avenue-11354", "145-president-street-11231", "147-east-86th-street-10028", "15-hudson-yards-10001", "150-east-23rd-street-10010", "2-park-place-10007", "2255-broadway-10024", "2717-42nd-road-11101", "301-east-81st-street-10028", "42-jay-street-11201", "50-jay-street-11201", "50-west-30th-street-10001", "80-adams-street-11201", "9-dekalb-avenue-11201", "98-front-street-11201", "1250-broadway-10001", "1289-lexington-avenue-10028", "1399-park-avenue-10029", "15-jay-street-10013", "152-elizabeth-street-10012", "157-west-57th-street-10019", "212-west-95th-street-10025", "217-west-57-street-10019", "22-thames-street-10006", "32-east-29th-street-10016", "34-east-29th-street-10016", "36-east-29th-street-10016", "4620-11th-street-11101", "49-chambers-street-10007", "70-vestry-street-10013", "76-schermerhorn-street-11201", "78-amity-street-11201", "80-east-10th-street-10003", "100-11th-avenue-10011", "100-amity-street-11201", "100-franklin-street-1001", "1053-46th-road-11101", "110-charlton-street-10014", "118-east-59th-street-10022", "126-willoughby-street-11201", "1325-fifth-avenue-10029", "134-stockton-street-11206", "134-west-83rd-street-10024", "150-charles-street-10014", "150-rivington-street-10002", "180-concord-street-11201", "193-henry-street-10002", "199-mott-street-10012", "2315-44-drive-11101", "233-broadway-10279", "2351-adam-clayton-powell-jr-boulevard-10030", "24-4th-avenue-11217", "25-kent-avenue-11249", "2516-37th-avenue-11101", "262-fifth-avenue-10001", "1-clinton-street-11201", "2937-41st-avenue-11101", "30-hudson-yards-10001", "309-ocean-pkwy-11218", "321-manhattan-avenue-11211", "350-henry-street-11201", "360-central-park-west-10025", "421-kent-avenue-11249", "425-park-avenue-10022", "4250-27th-street-11101", "50-west-66th-street-10023", "51-lincoln-place-11217", "511-herkimer-street-11213", "515-west-29th-street-10001", "53-west-53-street-10019", "55-west-17th-street-10011", "553-marcy-avenue-11206", "555-marcy-avenue-11206", "557-marcy-avenue-11206", "559-marcy-avenue-11206", "561-marcy-avenue-11206", "563-marcy-avenue-11206", "565-marcy-avenue-11206", "567-marcy-avenue-11206", "575-4th-avenue-11215", "607-west-56th-street-10019", "613-4th-avenue-11215", "631-east-18th-street-11226", "70-schermerhorn-street-11201", "753-bergen-street-11238", "76-11th-avenue-10011", "805-9th-avenue-10019", "833-myrtle-avenue-11206", "835-myrtle-avenue-11206", "837-myrtle-avenue-11206", "839-myrtle-avenue-11206", "841-myrtle-avenue-11206", "843-myrtle-avenue-11206", "845-myrtle-avenue-11206", "847-myrtle-avenue-11206", "849-myrtle-avenue-11206", "850-metropolitan-avenue-11211", "851-myrtle-avenue-11206", "853-myrtle-avenue-11206", "855-myrtle-avenue-11206", "859-myrtle-avenue-11206", "861-myrtle-avenue-11206", "863-myrtle-avenue-11206", "865-myrtle-avenue-11206", "867-myrtle-avenue-11206", "869-myrtle-avenue-11206", "929-atlantic-avenue-11238", "1-city-point-11201", "1-city-point-aka-138-willoughby-street-11201", "1-east-57th-street-10022", "1-vanderbilt-avenue-11205", "1-wall-street-10004", "1-world-trade-center-10007", "100-barrow-street-10014", "100-east-53rd-street-10152", "1008-decatur-street-11207", "101-west-78th-street-10024", "103-saint-james-place-11238", "104-stockton-street-11206", "108-chambers-street-10007", "10909-15th-avenue-11356", "11-beach-street-10013", "11-east-74th-street-10021", "11-east-75th-street-10021", "11-hancock-place-aka-362-west-125th-street-10001", "11-murray-street-10007", "110-5th-avenue-10011", "110-charlton-street-10013", "1105-cortelyou-road-11218", "1110-park-avenue-10128", "112-4th-avenue-11217", "114-stockton-street-11206", "116-beekman-street-10038", "116-university-place-10003", "116-west-127th-street-10027", "1170-5th-avenue-10029", "123-lafayette-street-10013", "125-east-63rd-street-10065", "13-east-75th-street-10021", "130-6th-avenue-11217", "13101-40th-road-11354", "1325-herkimer-street-11233", "13336-37th-avenue-11354", "13437-35-avenue-11354", "1355-1st-avenue-10021", "136-west-houston-street-10012", "137-4th-avenue-11217", "138-east-50-street-10022", "140-east-63rd-street-10065", "141-willoughby-street-11201", "14220-franklin-avenue-11355", "143-spring-street-10012", "144-west-34th-street-10001", "145-kent-street-11222", "14538-34th-avenue-11354", "146-west-34th-street-10001", "148-west-34th-street-10001", "149-east-86th-street-10028", "149-kent-street-11222", "15-bridge-park-drive-10013", "15-bridge-park-drive-11201", "15-central-park-west-10023", "15-cliff-street-10038", "15-east-19th-street-11226", "15-hubert-street-10013", "15-west-61-street-10023", "150-myrtle-ave-11201", "150-west-34th-street-10001", "150-wooster-street-10012", "1501-voorhies-avenue-11235", "151-east-86th-street-10028", "1511-fulton-avenue-10457", "1530-broadway-10036", "158-mercer-street-10012", "163-west-23rd-street-10011", "166-lafayette-avenue-11238", "169-west-95th-street-10025", "17-east-47th-street-10017", "171-columbia-heights-11201", "171-linden-boulevard-11226", "177-pacific-street-11201", "179-4th-avenue-11217", "181-president-street-11231", "184-kent-avenue-11249", "185-dean-street-11217", "19-dutch-street-10038", "1921-cortelyou-road-11226", "2-peck-slip-10038", "20-pine-street-10005", "200-east-20th-street-10003", "200-east-59th-street-10022", "200-water-street-10038", "2040-frederick-douglass-boulevard-10026", "205-water-street-11201", "21-east-22nd-street-10010", "211-central-park-west-10024", "211-schermerhorn-street-11201", "212-5th-avenue-10010", "212-5th-avenue-11215", "214-east-9th-street-10003", "218-west-57th-street-10019", "225-west-57th-street-10019", "23-8th-avenue-10014", "2314-44-drive-11101", "233-broadway-10007", "2343-31st-road-11106", "2349-adam-clayton-powell-jr-boulevard-10030", "236-broome-street-10002", "240-south-street-10002", "242-broome-street-10002", "247-cherry-street-10002", "247-west-115th-street-10026", "248-duffield-st-11201", "25-bond-street-10012", "250-ashland-place-11217", "250-bowery-10012", "250-church-street-10013", "250-water-street-10038", "250-west-27th-street-10001", "2508-40th-avenue-11101", "252-east-57-street-10022", "264-bainbridge-street-11233", "265-east-houston-street-10002", "270-park-avenue-10017", "280-richards-street-11231", "285-fulton-street-10007", "285-madison-avenue-10017", "2980-west-29th-street-11224", "3-east-54th-street-10022", "3-world-trade-center-10007", "30-east-29-street-10016", "30-park-place-10007", "30-park-place-11217", "300-west-44th-street-10036", "304-pearl-street-10038", "306-pearl-street-10038", "307-state-street-11201", "308-pearl-street-10038", "308-west-133rd-street-10030", "309-west-93rd-street-10025", "310-pearl-street-10038", "3110-28-road-11102", "312-canal-street-10013", "312-pearl-street-10038", "314-canal-street-10013", "315-meserole-street-11206", "316-canal-street-10013", "318-canal-street-10013", "32-east-1st-street-10003", "32-trinity-place-10006", "320-canal-street-10013", "3206-astoria-boulevard-11102", "322-canal-street-10013", "325-kent-avenue-11249", "3301-38th-avenue-11101", "335-west-35th-street-10001", "3420-bedford-avenue-11210", "346-broadway-10013", "347-henry-street-11201", "348-sackett-street-11231", "348-west-36th-street-10018", "35-hudson-yards-10001", "3514-surf-avenue-11224", "360-east-89th-street-10128", "361-sterling-place-11238", "362-van-brunt-street-11231", "368-adelphi-street-11238", "370-adelphi-street-11238", "3712-prince-street-11354", "372-west-end-avenue-10024", "38-east-29th-street-10016", "385-1st-avenue-10010", "39-south-portland-avenue-11217", "39-west-23rd-street-10010", "4-east-74th-street-10021", "4-peck-slip-10038", "40-10th-avenue-10014", "40-east-75th-street-10021", "411-15th-street-11215", "411-west-120-street-10027", "411-west-35th-street-10001", "417-prospect-place-11238", "42-crosby-street-10012", "42-trinity-place-10006", "420-west-broadway-1001", "422-west-49th-street-10019", "43-columbia-street-10002", "432 Park Avenue", "435-7th-avenue-10001", "436-albee-sq-11201", "436-albee-square-11201", "438-east-12th-street-10009", "44-jay-street-11201", "440-kent-avenue-11249", "440-washington-street-10013", "4415-purves-street-11101", "445-park-avenue-11205", "446-kent-avenue-11249", "446-west-167th-street-10032", "450-west-17th-street-10011", "450-west-33rd-street-10001", "456-washington-street-10013", "459-carroll-street-11215", "46-jay-street-11201", "460-west-42nd-street-10036", "4614-11th-street-11101", "463-east-178th-street-10457", "48-jay-street-11201", "4821-5th-street-11101", "485-madison-avenue-10022", "49-howard-street-10013", "4907-4th-avenue-11220", "5-bryant-park-10018", "50-e-28th-st-10016", "500-east-14th-street-10009", "500-seventh-avenue", "500-west-21st-street-10011", "501-west-24th-street-10011", "505-columbus-avenue-10024", "505-west-43rd-street-10036", "507-west-43rd-street-10036", "509-w-34th-st-10001", "509-west-43rd-street-10036", "51-east-42nd-street", "51-east-42nd-street-10017", "51-park-place-10007", "51-park-place-11217", "511-west-43rd-street-10036", "512-seventh-avenue-10018", "512-west-22nd-street-10011", "513-west-43rd-street-10036", "515-park-avenue-10022", "520-madison-avenue-10022", "520-park-avenue-10022", "520-west-28-street-10001", "525-west-122nd-street-10027", "526-west-28th-street-10001", "527-west-27th-street-10001", "529-w-29th-st-10001", "53-w-53rd-st-10019", "530-5th-avenue-10036", "530-west-30th-street-10001", "532-neptune-avenue-11224", "532-west-20th-street-10011", "535-atlantic-avenue-11217", "54-thompson-street-10012", "542-atlantic-avenue-11217", "542-broadway-10012", "543-48th-avenue-11101", "543-west-122-street-10027", "55-10th-avenue-10014", "55-5th-avenue-10003", "550-4th-avenue-11215", "550-washington-street-10014", "56-willow-street-11201", "560-west-33-street-10001", "569-marcy-avenue-11206", "569-marcy-avenue-11206569-marcy-avenue-11206", "570-lexington-avenue-11221", "58-saint-marks-place-11217", "58-west-135th-street-10037", "591-third-avenue-10016", "6-east-57th-street-10022", "6-peck-slip-10038", "609-5th-avenue-10017", "62-avenue-b-10009", "620-madison-avenue-10022", "620-park-avenue-10065", "6208-8th-avenue-11220", "63-flushing-avenue-11205", "636-11th-avenue-10036", "640-5th-avenue-10019", "646-11th-avenue-10036", "650-madison-avenue-10022", "67-greene-street-10012", "68-schermerhorn-street-11201", "680-madison-avenue-10065", "701-7th-avenue-10036", "71-laight-street-10013", "719-7th-avenue-10036", "720-nostrand-avenue-11216", "75-west-broadway-10007", "75-west-end-avenue-10023", "770-lexington-avenue-11221", "8-peck-slip-10038", "8-saint-marks-place-11217", "8-spruce-street-10038", "80-flatbush-avenue-extension-11201", "805-washington-avenue-11238", "806-dekalb-avenue-11221", "816-5th-avenue-11232", "817-5th-avenue-11232", "820-5th-avenue-10065", "83-walker-street-10013", "831-washington-street-10014", "834-5th-avenue-10065", "845-united-nations-plaza-10017", "85-10th-avenue-10011", "850-3rd-avenue-10022", "856-washington-avenue-11238", "857-myrtle-avenue-11206", "86-warren-street-10007", "87-leonard-street-10013", "876-broadway-10003", "88-lexington-avenue-10016", "9-east-75th-street-10021", "90-furman-street-11201", "906-prospect-place-11213", "925-atlantic-avenue-11238", "927-atlantic-avenue-11238", "931-carroll-street-11225", "946-myrtle-avenue-11206", "95-east-houston-street-10002", "954-bergen-street-11216", "969-madison-avenue-10021", "9745-63rd-drive-11374", "9907-3rd-avenue-11209", "john-credaroli-iii", "one-willoughby-square-11201", "35-hudson-yards-10001", "15-hudson-yards-10001"];


export const _typeformPopupLink = 'https://marketproof.typeform.com/to/U6laaV';

export const _typeformPopupProLink = 'https://marketproof.typeform.com/to/q44rFC';

export const _axiosCall = async data => {
  //console.log('axios call ', data);
  
  if(data.url.indexOf('/query/')>=0){
	  const cacheOff = localStorage && localStorage.getItem(`admin-cache-off`) && localStorage.getItem(`admin-cache-off`) ===  'true' ? true : false;
	  console.log('admincache', localStorage.getItem(`admin-cache-off`))	  
	  if(cacheOff && typeof URL === 'function'){
		  let href = new URL(data.url);
		  //if(!href.searchParams.get('always-cache')){
            href.searchParams.set("cache", "refresh");
          //}
		  data.url = href.toString();
	  }
	  
  }
   if(data.url.indexOf('/buildings/')>=0){
	  const cacheOff = localStorage && localStorage.getItem(`admin-cache-off`) && localStorage.getItem(`admin-cache-off`) ===  'true' ? true : false;
	  console.log('admincache', localStorage.getItem(`admin-cache-off`))	  
	  if(cacheOff && typeof URL === 'function'){
		  let href = new URL(data.url);
		  href.searchParams.set('nocache', 'true');
		  data.url = href.toString();
	  }
	  
  }
  var time = Math.floor(Date.now() / 1000);  
  var r1 = Math.floor(Math.random() * 900000000) + 100000000;
  var r2 = Math.floor(Math.random() * 900000000) + 100000000;
  var t = btoa(r1.toString() + time.toString() + r2.toString());
  axios.defaults.headers.common['vhmc2a89xue4bcbr'] = t;
  const response = await axios({
    method: data.method,
    url: data.url,
    data: data.query,
    params: data.params,
    headers: data.headers
  })
    .then(res => {
      console.log('bl axios res back', res)
      return res.data;
    })
    .catch(error => {
      // const toastContainer = document.getElementById("toast-container");
      // if (!toastContainer) {
      //   console.log("Badness on AXIOS: " + error);
      //   console.log("axios error toast fired");
      //   toast.error('Something went wrong! Please try again later.', { autoClose: 3000 });
      // }
      console.log("Badness on AXIOS: ", error.response)
      if(error.response && error.response.data){
	      return error.response.data
      }else{
	      throw error.response ? error.response : false;
      }
    });
  
  // console.log('check response ', response)
  return response;
};

export const _makeBuildingAxiosData = (data, listingKey = false) => {
  //console.log('_makeBuildingAxiosData data', data, 'listingKey', listingKey)
  if (data.method === "get") {
    data.query = {};
  } else {
    data.query = {
      query: {
        borough: [],
        building_slugs: data.type === "building" ? data.arr : [],
        building_units: [],
        company_slugs: [],
        neighborhood: [],
        person_slugs: []
      },
      bedrooms: [],
      company_slugs: [],
      event_tags: [],
      person_slugs: [],
      price: [],
      rows: 0,
      sort: "time desc",
      start: 0,
      topic: ["listings", "permits", "offeringplans", "transactions"],
      units: [],
      json_stats: {
        topic: {
          type: "terms",
          field: "topic",
          limit: 20,
          domain: {
            filter:
              "time:[NOW-" +
              data.timeFrame.toString().toUpperCase() +
              " TO NOW]"
          }
        },
        people: {
          type: "terms",
          field: "person_slugs",
          limit: 100,
          domain: {
            filter:
              "time:[NOW-" +
              data.timeFrame.toString().toUpperCase() +
              " TO NOW] AND -topic:stories"
          }
        },
        company: {
          type: "terms",
          field: "company_slugs",
          limit: 20,
          domain: {
            filter:
              "time:[NOW-" +
              data.timeFrame.toString().toUpperCase() +
              " TO NOW] AND -topic:stories"
          }
        }
      }
    };
  }

  // add building slugs to url 
  if (Array.isArray(data.arr) && data.arr.length > 1) {
    // update to multiUrl val if it exists
    data.url = data.multiUrl ? data.multiUrl : "";
    data.arr.forEach((slug, i) => {
      if (i !== data.arr.length - 1) {
        data.slugUrl += encodeURIComponent(slug) + ",";
      } else {
        data.slugUrl += encodeURIComponent(slug);
      }
    });
    data.url += data.slugUrl;
  } else {
    // check for listing key and add if present
    data.url = data.singleUrl + (listingKey ? "listings/" + listingKey + "/" : "");
    data.slugUrl = encodeURIComponent(data.arr);
    data.url += data.slugUrl;
  }

  return data;
};


export const _getUserSSO = (ssoToken, props, setUserProfile) => {
 
  
  const { authState, authService, dispatch } = props;
      
  let headers = {
    "Authorization" : `Bearer ${ssoToken.access_token}`,
  }
  let userData = {
      url: `${process.env.REALOGY_BASE_URL}userinfo`,
      method: "get",
      headers:headers
  };
  
  
  _axiosCall(userData)
    .then(res => {
    console.log("_getUserData res back ,", res);
    if(res){
      let oktaUser = Object.assign({}, res);
      oktaUser['authType'] = 'sso';
      oktaUser['role'] = 'complete-199';
      oktaUser['subscriptionPlan'] = 'custom-sso';
      oktaUser['id']= res.sub;
      oktaUser['firstName'] = res.given_name;
      oktaUser['lastName'] = res.family_name;
      dispatch(setUserProfile(oktaUser));
    }
    

  })
  .catch(error => {
    console.log("_getUserData error ", error);
    dispatch(setUserProfile(null));
  });
}
export const _getNeighborhoods = async (searchTags, obj) => {
  const hoods = searchTags.filter((item) => (item.type === "neighborhood"));
  console.log("_getNeighborhoods hoods", hoods, "obj", obj);
  if (!hoods || hoods.length < 1) {
    if (typeof obj.callback === "function") {
      obj.callback(false);
    }
    return false;
  }
  console.log(hoods);
  var fqs = hoods.map((tag) => {
    let data = tag.data;
    let hood_key =
      data.hood
        .replace("'", "")
        .replace("co-op city", "co-op")
        .replace(/\s+/g, "-")
        .replace("south-ozone-park", "south-ozone*")
        .toLowerCase() +
      "_" +
      data.boro.replace(/\s+/g, "-").toLowerCase();

    return "(key:" + hood_key + "*)";
  });

  var query = fqs.join(" OR ");

  const hoodCall = {
    url: obj.url + "search-geocode",
    method: "post",
    query: {
      q: query,
      wt: "json",
      fq: "type:minor",
      rows: 500,
    },
  };

  var hoodData = await _axiosCall(hoodCall)
    .then((res) => {
      // console.log('getProperties call ', res);
      return res;
    })
    .catch((error) => {
      // console.log('inventory listings error: ', error);
    });

  //console.log(properties);
  if (typeof obj.callback === "function") {
    if (hoodData.docs && hoodData.docs.length > 0) {
      hoodData.docs.forEach((hood) => {
        if (hood.loc) {
          hood["coordinates"] = hood.loc
            .replace("Polygon((", "")
            .replace("))", "")
            .split(", ")
            .map((coord) => {
              return coord.split(" ");
            });
        }
      });
      obj.callback(hoodData.docs);
    } else {
      obj.callback(false);
    }
  }
};

export const _getNeighborhoodsAll = async (obj) => {
  var fqs = [
    'region:("brooklyn" "manhattan" "bronx" "staten island" "queens")',
    "type:minor",
  ];

  var query = fqs.join(" OR ");

  const hoodCall = {
    url: obj.url + "search-geocode",
    method: "post",
    query: {
      q: query,
      wt: "json",
      fq: fqs,
      rows: 500,
    },
  };

  var hoodData = await _axiosCall(hoodCall)
    .then((res) => {
      // console.log('getProperties call ', res);
      return res;
    })
    .catch((error) => {
      // console.log('inventory listings error: ', error);
    });

  //console.log(properties);
  if (typeof obj.callback === "function") {
    if (hoodData.docs && hoodData.docs.length > 0) {
      hoodData.docs.forEach((hood) => {
        if (hood.loc) {
          hood["coordinates"] = hood.loc
            .replace("Polygon((", "")
            .replace("))", "")
            .split(", ")
            .map((coord) => {
              return coord.split(" ");
            });
        }
      });
      obj.callback(hoodData.docs);
    } else {
      obj.callback(false);
    }
  }
};
export const _getDOBComplaints = async (building, obj) => {
 let query = _getBuidingQuery(building);

  //console.log(query);
  var violationCallData = {
    url: obj.url + "we3-dob-complaints",
    method: "post",
    query: {
      q: query,
      wt: "json",
      sort: "date_entered desc",
      rows: 500,
    },
  };
  let formattedData = await _axiosCall(violationCallData).catch((error) => {
      console.log("error: " + error);
    });

  // console.log(formattedData)
  return formattedData;
};

export const _getECBViolations = async (building, obj) => {
 let query = _getBuidingQuery(building);

  //console.log(query);
  var violationCallData = {
    url: obj.url + "we3-dob-311",
    method: "post",
    query: {
      q: query,
      wt: "json",
      sort: "entered_date desc",
      rows: 500,
    },
  };
  let formattedData = await _axiosCall(violationCallData).catch((error) => {
      console.log("error: " + error);
    });

  // console.log(formattedData)
  return formattedData;
};

//building adr check done on func call in component
export const _getHPDViolations = async (building, obj) => {
 let query = _getBuidingQuery(building);

  //console.log(query);
  var violationCallData = {
    url: obj.url + "we3-hpd-violations",
    method: "post",
    query: {
      q: query,
      wt: "json",
      sort: "nov_issued_date desc",
      rows: 500,
    },
  };
  
  let formattedData = await _axiosCall(violationCallData).catch((error) => {
      console.log("error: " + error);
    });

  // console.log(formattedData)
  return formattedData;
};


//building adr check done on func call in component
export const _getDOBViolations = async (building, obj) => {
  
 
  let query = _getBuidingQuery(building);

  var violationCallData = {
    url: obj.url + "we3-dob-violations",
    method: "post",
    query: {
      q: query,
      wt: "json",
      sort: "issue_date desc",
      rows: 500,
    },
  };
  let formattedData = await _axiosCall(violationCallData).catch((error) => {
      console.log("error: " + error);
    });

  // console.log(formattedData)
  return formattedData;
};

const queryURL = process.env.API_ROOT + '/query/';

export const _getSubways = async (building) => {
  const geocode = building.geocode;
  if (!geocode) return {};
  const subwayCallData = {
    url: queryURL + "mta-subway?cache=86400",
    method: "post",
    query: {
      q: "*:*",
      wt: "json",
      fq: "{!geofilt}",
      sfield: "geocode",
      pt: geocode,
      d: "2",
      sort: "geodist() asc",
      fl: "*,score,geodist()",
      rows: 40
    }
  };
  let formattedData = await _axiosCall(subwayCallData)
    .then(res => {
      var subways = {};
      if (res && res.docs && res.docs.length > 0) {
        for (var i = 0; i < res.docs.length; i++) {
          var val = res.docs[i];
          var station = {
            station_name: val.station_name,
            subway_lines: val.subway_lines,
            subway_lines_display: val.subway_lines_display,
            geocode: val.geocode,
            distance: Math.round(parseFloat(val["geodist()"]) * 0.621371 * 100) / 100
          };
          if (Object.keys(subways).length <= 5) {
            if (!subways[val.subway_lines_display]) {
              subways[val.subway_lines_display] = station;
            }
          }
        }
      }
      return subways;
    })
    .catch(error => {
      console.log("error: " + error);
      return {};
    });
  return formattedData;
};

export const _getZonedSchools = async (building) => {
  const geocode = building.geocode;
  if (!geocode) return {};
  const lat_lng = geocode.indexOf(",") >= 0 ? geocode.split(", ") : [0, 0];
  const query = 'polygon:"Intersects(' + lat_lng[1] + " " + lat_lng[0] + ')"';
  const callData = {
    url: queryURL + "doe-school-zones?cache=86400",
    method: "post",
    query: {
      q: query,
      wt: "json",
      rows: 40
    }
  };
  let formattedData = await _axiosCall(callData)
    .then(res => {
      var zones = {};
      if (res && res.docs && res.docs.length > 0) {
        for (var i = 0; i < res.docs.length; i++) {
          var val = res.docs[i];
          zones[val.school_type] = val;
        }
      }
      return zones;
    })
    .catch(error => {
      console.log("error: " + error);
      return {};
    });
  return formattedData;
};

export const _getNearbySchools = async (building) => {
  const geocode = building.geocode;
  if (!geocode) return {};
  const callData = {
    url: queryURL + "doe-schools?cache=86400",
    method: "post",
    query: {
      q: "*:*",
      wt: "json",
      fq: "{!geofilt}",
      sfield: "geocode",
      pt: geocode,
      d: "3",
      sort: "geodist() asc",
      fl: "*,score,geodist()",
      rows: 40
    }
  };
  let formattedData = await _axiosCall(callData)
    .then(res => {
      var schools = {};
      if (res && res.docs && res.docs.length > 0) {
        for (var i = 0; i < res.docs.length; i++) {
          var val = res.docs[i];
          var aKey = val.location_category_description.replace(" ", "_");
          if (val.location_category_description === "Secondary School") {
            aKey = "junior_high-intermediate-middle";
          }
          if (val.location_category_description === "K-8" || val.location_category_description === "K-12") {
            aKey = "elementary";
          }
          aKey = aKey.toLowerCase();
          val["distance"] = Math.round(parseFloat(val["geodist()"]) * 0.621371 * 100) / 100;
          if (Array.isArray(schools[aKey])) {
            if (schools[aKey].length < 4) {
              schools[aKey].push(val);
            }
          } else {
            schools[aKey] = [val];
          }
        }
      }
      return schools;
    })
    .catch(error => {
      console.log("error: " + error);
      return {};
    });
  return formattedData;
};

export const _getBuidingQuery = (building) => {
  const bblQuery = building.address && building.address.block
    ? `(block:${building.address.block} AND lot:${building.address.lot} AND borough_code:${building.address.borough_code})`
    : building.block ? 
    `(block:${building.block} AND lot:${building.lot} AND borough_code:${building.borough_code})`
    : false;
  const addressQ =
    building.address && building.address.alternate_addresses
      ? building.address.alternate_addresses.join('" OR "')
      : building.alternate_addresses ? 
       building.alternate_addresses.join('" OR "') 
      : false;
      
  const zip = building.address && building.address.zip 
  ? building.address.zip
  : building.zip ?
    building.zip 
  : false;
  const borough = building.address && building.address.borough 
  ? building.address.borough
  : building.borough ?
    building.borough 
  : false;
  
  let query = `(alternate_addresses:("${addressQ}") AND (zip:${zip} OR borough:"${borough}"))`;
  
  if (bblQuery) {
    query = `(${query}  OR ${bblQuery})`;
  }
  
  return query;
  
}

